module.exports = __webpack_public_path__ + "static/media/down-arrow.8ee9bfeb.svg";